import { FolderSearch } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
} from '@/components/ui/empty'
import { useNavigate } from '@tanstack/react-router'
import { Typography } from '@/components/ui/typography'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface NotFoundProps {
  title?: string
  icon?: ReactNode
  description?: string
  onActionLabel?: string
  useCard?: boolean
  className?: string
  headerClassName?: string
  mediaClassName?: string
  titleClassName?: string
  descriptionClassName?: string
  onAction?: () => void
}

const NotFound = ({
  title = 'Page not found',
  icon = <FolderSearch strokeWidth={0.75} className="size-32 text-primary" />,
  description = 'The page you are looking for does not exist or may have been moved.',
  onActionLabel = 'Go Back To Home',
  onAction,
  useCard = false,
  className,
  headerClassName,
  titleClassName,
  descriptionClassName,
}: NotFoundProps) => {
  const navigate = useNavigate()

  const handleAction = () => {
    if (onAction) {
      onAction()
    } else {
      navigate({ to: '/' })
    }
  }

  return (
    <Empty
      className={cn(
        useCard
          ? 'border border-solid border-sidebar-border rounded-xl shadow-xs'
          : '',
        className
      )}
    >
      <EmptyHeader className={headerClassName}>
        <EmptyMedia variant="default">{icon}</EmptyMedia>
        <Typography
          as="h1"
          variant="h2"
          className={cn('text-center', titleClassName)}
        >
          {title}
        </Typography>
        <EmptyDescription className={cn('text-center', descriptionClassName)}>
          {description}
        </EmptyDescription>
      </EmptyHeader>
      <Button onClick={handleAction}>{onActionLabel}</Button>
    </Empty>
  )
}

export { NotFound }
